import { useAtom } from "jotai";

import { hideHistoricalFindingsAtom } from "@shared/state";

export const useHideHistoricalFindings = () => {
  return useAtom(hideHistoricalFindingsAtom);
};
